/**
 * P1 (AN-PP1 §7): reclassificação de "Outra necessidade" pelo back-office.
 *
 * Contrato ASSUMIDO a partir do desenho (o backend DEV-PP1-O é feito em paralelo): o POST
 * devolve a reserva atualizada; o GET devolve as linhas append-only de
 * `reclassificacoes_produto_reserva`. Ajustar aqui na integração se os nomes divergirem.
 */
export interface ReclassificarProdutoRequest {
  produtoId: string
  /** Obrigatório, até 500 caracteres (422 `MOTIVO_OBRIGATORIO`). */
  motivo: string
}

export interface ReclassificacaoProduto {
  id: string
  oportunidadeId: string
  /** Nulo = reserva legada sem produto. */
  produtoAnteriorId?: string | null
  produtoAnteriorCodigo?: string | null
  /** O texto livre original da "Outra necessidade". */
  tipoNecessidadeAnterior: string
  produtoNovoId: string
  produtoNovoCodigo: string
  produtoNovoNome: string
  statusReserva: string
  motivo: string
  /** Só para o back-office — o consultor dono recebe sem autor (Q-PP1-7). */
  autorId?: string | null
  autorNome?: string | null
  ocorridoEm: string
}

/** Tamanho máximo do motivo (mesmo limite da coluna `motivo VARCHAR(500)`). */
export const TAMANHO_MAXIMO_MOTIVO_RECLASSIFICACAO = 500

/**
 * Status em que a reclassificação é aceita (AN-PP1 §7.1, Q-PP1-3). A tela só usa para explicar
 * por que o botão está desabilitado — quem decide é o backend (409).
 */
export const STATUS_RECLASSIFICAVEIS: ReadonlySet<string> = new Set([
  'ENVIADA',
  'EM_ANALISE_ORIGINEI',
  'COM_PENDENCIA',
  'APROVADA_ORIGINEI',
])
